import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Container from 'components/Container';
import ResponsiveImage from 'components/ResponsiveImage';
import SectionHeader from 'components/SectionHeader';

export default function CategoriesBlock({ block }) {
  const { t } = useTranslation();
  const id = `blk-${block.id}`;
  return (
    <section aria-labelledby={id} className="py-12 lg:py-16">
      <Container>
        <SectionHeader id={id} title={block.title} intro={block.intro} />
        <ul className="no-scrollbar -mx-4 mt-8 flex snap-x snap-mandatory scroll-px-4 gap-3 overflow-x-auto px-4 sm:-mx-6 sm:scroll-px-6 sm:px-6 lg:mx-0 lg:grid lg:grid-cols-6 lg:gap-5 lg:overflow-visible lg:px-0">
          {block.categories.map((c) => (
            <li key={c.slug} className="w-[42%] shrink-0 snap-start sm:w-[28%] lg:w-auto">
              <Link to={`/kategori/${c.slug}`} className="group block">
                <span className="block aspect-[4/5] overflow-hidden rounded bg-surface-alt">
                  <ResponsiveImage
                    image={c.image}
                    alt=""
                    sizes="(min-width: 1024px) 15vw, 42vw"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                  />
                </span>
                <span className="mt-3 block text-[15px] font-medium text-ink group-hover:underline group-hover:underline-offset-4">
                  {c.name}
                </span>
                <span className="block text-[13px] text-muted">
                  {t('category.productCount', { count: c.productCount })}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
